import { Home, LogOut } from "lucide-react";
import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { toast } from "react-toastify";
import { httpService } from "../httpService";
import { Link } from "react-router-dom";

function NavbarComponent() {
  const [loading, setLoading] = useState(false);
  const links = [
    // { link: "/", text: "Home" },
    // { link: "/currentposting", text: "Current Posting" },
    // { link: "/profile", text: "Profile" },
  ];

  const logoutAccount = async () => {
    setLoading(true);
    const { data, error } = await httpService("logout");

    if (data) {
      window.location.assign("/");
      localStorage.removeItem("refreshToken");
    }
    if (error) {
      toast.error(error);
    }
    setLoading(false);
  };
  return (
    <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary mb-4">
      <Container>
        <Navbar.Brand className="d-flex align-items-center" as={Link} to="/">
          Home
          <Home className="ms12" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
            {links.map((c, i) => (
              <Nav.Link key={i} as={Link} to={c.link}>
                {c.text}
              </Nav.Link>
            ))}
          </Nav>
          <Nav>
            {/* <Nav.Link href="#deets">More deets</Nav.Link> */}
            <Nav.Link eventKey={2} onClick={logoutAccount}>
              Logout <LogOut />
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavbarComponent;
